module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 170
// module chunks = 0